import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../api/AuthService";
import { useAlert } from "../../context/AlertContext";
import UniversalTaxPage from "../../entities/UniversalTaxPage";
import LoaderHelper from "../../utils/Loader/LoaderHelper";

const UniversalTax = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { country, label } = location.state || {};
  const [loading, setLoading] = useState();
  const { showAlert } = useAlert();
  const [data, setData] = useState();
  const [page, setPage] = useState();
  const [totalPage, setTotalPage] = useState();
  const [totalCount, setTotalCount] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    getTaxRule(country, label?.title);
  }, []);

  const getTaxRule = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getTaxRule(country, label?.title);
      if (result?.success) {
        setData(result?.data?.data);
        setTotalPage(result?.data?.totalPages);
        setTotalCount(result?.data?.totalCount);
        setPage(result?.data?.currentPage);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const normalizeTaxRulePayload = (payload) => {
    const formatDate = (date) =>
      date ? dayjs(date).format("YYYY-MM-DD") : undefined;

    return {
      ...payload,
      startDate: formatDate(payload.startDate),
      endDate: formatDate(payload.endDate),
    };
  };

  const handleAddTaxRule = async (payload) => {
    setLoading(true);
    try {
      const result = await AuthService.addTaxRule(
        normalizeTaxRulePayload(payload)
      );
      if (result?.success === true) {
        getTaxRule(country, label?.title);
        setLoading(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };

  const deleteTaxRule = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteTaxRule(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getTaxRule(country, label?.title);
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleEditTaxRule = async (id, payload) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.updateTaxRule(
        id,
        normalizeTaxRulePayload(payload)
      );
      if (result?.success) {
        getTaxRule(country, label?.title);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message, "error");
    }
  };

  const handleDeleteTaxRule = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      if (data.length) {
        // Delete all tax rules for the tax label
        const result = await AuthService.deleteTaxRules(country, label?.title);
        if (!result?.success) {
          LoaderHelper.loaderStatus(false);
          showAlert(result?.message, "error");
        }
      }

      // Delete tax label
      const result = await AuthService.deleteTaxLabel(label._id);
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        setTimeout(() => {
          navigate("/dashboard/ControlCentre");
        }, 1000);
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message, "error");
    }
  };
  return (
    <UniversalTaxPage
      country={country}
      totalCount={totalCount}
      handleEditTaxRule={handleEditTaxRule}
      totalPage={totalPage}
      deleteTaxRule={deleteTaxRule}
      handleDeleteTaxRule={handleDeleteTaxRule}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      data={data}
      handleAddTaxRule={handleAddTaxRule}
      loading={loading}
      label={label}
    />
  );
};

export default UniversalTax;
